export const PRE_SIGNUP_REQUEST = "PRE_SIGNUP_REQUEST";
export const PRE_SIGNUP_SUCCESS = "PRE_SIGNUP_SUCCESS";
export const PRE_SIGNUP_FAIL = "PRE_SIGNUP_FAIL";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_SUCCESS_GOOGLE = "LOGIN_SUCCESS_GOOGLE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const EDIT_USER_REQUEST = "EDIT_USER_REQUEST";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAIL = "EDIT_USER_FAIL";
export const EDIT_USER_RESET = "EDIT_USER_RESET";

export const DEACTIVATE_USER_ACCOUNT_REQUEST =
  "DEACTIVATE_USER_ACCOUNT_REQUEST";
export const DEACTIVATE_USER_ACCOUNT_SUCCESS =
  "DEACTIVATE_USER_ACCOUNT_SUCCESS";
export const DEACTIVATE_USER_ACCOUNT_RESET_SUCCESS =
  "DEACTIVATE_USER_ACCOUNT_RESET_SUCCESS";
export const DEACTIVATE_USER_ACCOUNT_FAIL = "DEACTIVATE_USER_ACCOUNT_FAIL";
export const DEACTIVATE_USER_ACCOUNT_CLEAR_ERRORS =
  "DEACTIVATE_USER_ACCOUNT_CLEAR_ERRORS";

export const DELETE_USER_ACCOUNT_REQUEST = "DELETE_USER_ACCOUNT_REQUEST";
export const DELETE_USER_ACCOUNT_SUCCESS = "DELETE_USER_ACCOUNT_SUCCESS";
export const DELETE_USER_ACCOUNT_RESET_SUCCESS =
  "DELETE_USER_ACCOUNT_RESET_SUCCESS";
export const DELETE_USER_ACCOUNT_FAIL = "DELETE_USER_ACCOUNT_FAIL";
export const DELETE_USER_ACCOUNT_CLEAR_ERRORS =
  "DELETE_USER_ACCOUNT_CLEAR_ERRORS";

export const CHANGE_USER_PASSWORD_REQUEST = "CHANGE_USER_PASSWORD_REQUEST";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_RESET = "CHANGE_USER_PASSWORD_RESET";
export const CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL";

export const FORGOT_USER_PASSWORD_REQUEST = "FORGOT_USER_PASSWORD_REQUEST";
export const FORGOT_USER_PASSWORD_SUCCESS = "FORGOT_USER_PASSWORD_SUCCESS";
export const FORGOT_USER_PASSWORD_CLEAR_SUCCESS =
  "FORGOT_USER_PASSWORD_CLEAR_SUCCESS";
export const FORGOT_USER_PASSWORD_FAIL = "FORGOT_USER_PASSWORD_FAIL";

export const RESET_USER_PASSWORD_REQUEST = "RESET_USER_PASSWORD_REQUEST";
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS";
export const RESET_USER_PASSWORD_FAIL = "RESET_USER_PASSWORD_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

// For admin
export const ADMIN_USERS_REQUEST = "ADMIN_USERS_REQUEST";
export const ADMIN_USERS_SUCCESS = "ADMIN_USERS_SUCCESS";
export const ADMIN_USERS_FAIL = "ADMIN_USERS_FAIL";

export const ADMIN_USER_DETAILS_REQUEST = "ADMIN_USER_DETAILS_REQUEST";
export const ADMIN_USER_DETAILS_SUCCESS = "ADMIN_USER_DETAILS_SUCCESS";
export const ADMIN_USER_DETAILS_FAIL = "ADMIN_USER_DETAILS_FAIL";

export const ADMIN_UPDATE_USER_REQUEST = "ADMIN_UPDATE_USER_REQUEST";
export const ADMIN_UPDATE_USER_SUCCESS = "ADMIN_UPDATE_USER_SUCCESS";
export const ADMIN_UPDATE_USER_RESET = "ADMIN_UPDATE_USER_RESET";
export const ADMIN_UPDATE_USER_FAIL = "ADMIN_UPDATE_USER_FAIL";

export const ADMIN_DELETE_USER_REQUEST = "ADMIN_DELETE_USER_REQUEST";
export const ADMIN_DELETE_USER_SUCCESS = "ADMIN_DELETE_USER_SUCCESS";
export const ADMIN_DELETE_USER_RESET = "ADMIN_DELETE_USER_RESET";
export const ADMIN_DELETE_USER_FAIL = "ADMIN_DELETE_USER_FAIL";
